import { Box, Container, Flex, SimpleGrid, VStack } from "@chakra-ui/react";

export function LoadingState() {
  return (
    <Container maxW="7xl" py={8}>
      <VStack gap={8} align="stretch">
        {/* Header Skeleton */}
        <Flex justify="space-between" align="center">
          <Box />
          <Box h="12" w="120px" bg="gray.200" rounded="md" />
        </Flex>

        {/* Stats Cards Skeleton */}
        <SimpleGrid columns={{ base: 1, md: 4 }} gap={6}>
          {[1, 2, 3, 4].map((i) => (
            <Box
              key={i}
              p={6}
              bg="white"
              rounded="xl"
              shadow="sm"
              border="1px"
              borderColor="gray.100"
            >
              <Box h="4" w="100px" bg="gray.200" rounded="md" mb={3} />
              <Box h="8" w="80px" bg="gray.300" rounded="md" mb={2} />
              <Box h="3" w="120px" bg="gray.100" rounded="md" />
            </Box>
          ))}
        </SimpleGrid>

        {/* Table Skeleton */}
        <Box
          bg="white"
          rounded="xl"
          shadow="lg"
          border="1px"
          borderColor="gray.200"
          overflow="hidden"
        >
          <Box p={4} borderBottom="1px" borderColor="gray.200">
            <Box h="10" w="250px" bg="gray.200" rounded="md" />
          </Box>
          <Box p={4}>
            {[1, 2, 3, 4, 5].map((i) => (
              <Box key={i} h="12" bg="gray.50" rounded="md" mb={3} />
            ))}
          </Box>
        </Box>
      </VStack>
    </Container>
  );
}
